import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { unescapeHTML } from '@as-react/common-utils';
import { Hydrater } from '@as-react/hydrater';
import { Logger } from '@as-react/logger';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { availableComponents, renderingTools } from '../../../index';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
export const RowBanner = ({ content }) => {
    const containerEl = useRef(null);
    const { i18n } = useTranslation();
    const { locale, translationLang } = useAemConfig();
    useEffect(() => {
        !!containerEl.current &&
            Hydrater({
                availableComponents,
                root: containerEl.current,
                renderingTools,
                locale,
                translationLang,
                i18n,
            }).catch(Logger.logError);
    }, []);
    return (_jsx("div", { ref: containerEl, "data-testid": "row-banner", children: _jsx(HtmlInclude, { htmlFragment: unescapeHTML(content) }) }));
};
